import { render, staticRenderFns } from "./expo-program-dashboard.vue?vue&type=template&id=4bb605b3"
import script from "./expo-program-dashboard.vue?vue&type=script&lang=js"
export * from "./expo-program-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports